

export class DeviceWithStatusOutputData implements IDeviceWithStatusOutputData {
    /** The auto-generated id of the device master */
    device_id!: number;
    /** The branch name with 255 character */
    branch!: string;
    /** The company name with 255 character */
    company_name!: string;
    /** The vehicle with name and number */
    vehicle!: string;
    /** The vehicle type name with 255 character */
    vehicle_type_name!: string;
    /** The vehicle model name with 255 character */
    vehicle_model_name!: string;
    /** The sim card number with 255 character */
    card_number!: string;
    /** The sim card number with 255 character */
    secondary_sim!: string;
    /** The IMEI number with 500 character */
    imei_number!: string;
    /** The device name with 255 character" */
    device_name!: string;
    /** The auto-generated creating time of tbl_vehicle_group item add */
    creating_date!: any;
    /** The expiry date should be with 10 character */
    installation_date!: string;
    /** The number of allocated port to device */
    allocated_port_count!: number;
    /** Manage status of device. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IDeviceWithStatusOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_id = _data["device_id"];
            this.branch = _data["branch"];
            this.company_name = _data["company_name"];
            this.vehicle = _data["vehicle"];
            this.vehicle_type_name = _data["vehicle_type_name"];
            this.vehicle_model_name = _data["vehicle_model_name"];
            this.card_number = _data["card_number"];
            this.secondary_sim = _data["secondary_sim"];
            this.imei_number = _data["imei_number"];
            this.device_name = _data["device_name"];
            this.creating_date = _data["creating_date"];
            this.installation_date = _data["installation_date"];
            this.allocated_port_count = _data["allocated_port_count"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DeviceWithStatusOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceWithStatusOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_id"] = this.device_id;
        data["branch"] = this.branch;
        data["company_name"] = this.company_name;
        data["vehicle"] = this.vehicle;
        data["vehicle_type_name"] = this.vehicle_type_name;
        data["vehicle_model_name"] = this.vehicle_model_name;
        data["card_number"] = this.card_number;
        data["secondary_sim"] = this.secondary_sim;
        data["imei_number"] = this.imei_number;
        data["device_name"] = this.device_name;
        data["creating_date"] = this.creating_date;
        data["installation_date"] = this.installation_date;
        data["allocated_port_count"] = this.allocated_port_count;
        data["status"] = this.status;
        return data; 
    }
}

export interface IDeviceWithStatusOutputData {
    /** The auto-generated id of the device master */
    device_id: number;
    /** The branch name with 255 character */
    branch: string;
    /** The company name with 255 character */
    company_name: string;
    /** The vehicle with name and number */
    vehicle: string;
    /** The vehicle type name with 255 character */
    vehicle_type_name: string;
    /** The vehicle model name with 255 character */
    vehicle_model_name: string;
    /** The sim card number with 255 character */
    card_number: string;
    /** The sim card number with 255 character */
    secondary_sim: string;
    /** The IMEI number with 500 character */
    imei_number: string;
    /** The device name with 255 character" */
    device_name: string;
    /** The auto-generated creating time of tbl_vehicle_group item add */
    creating_date: any;
    /** The expiry date should be with 10 character */
    installation_date: string;
    /** The number of allocated port to device */
    allocated_port_count: number;
    /** Manage status of device. 0 For De-active, 1 For Active */
    status: number;
}

